import React from 'react';
import { Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { ModalFooter } from 'components/common/modals';
import { ButtonV2 } from 'components/common/ui';
import { FieldV2 } from 'components/common/form-controls';
import { rolesOptions } from '../rolesOptions';
import addAgentFormValidationSchema from './addAgentFormValidationSchema';
import style from './addAgentForm.style';

const AddAgentModalForm = ({
  defaultValues = {},
  isLoading,
  onSubmit,
  onClose,
}) => {
  const resolver = yupResolver(addAgentFormValidationSchema);

  const methods = useForm({
    defaultValues,
    resolver,
  });

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const rolesOptionsModified = rolesOptions
    .map((option) => ({
      ...option,
      text: option.label,
    }))
    .sort((a, b) => a.text.localeCompare(b.text));

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Box sx={style.row}>
          <FieldV2
            name="firstName"
            isRequired
            disabled={isLoading}
            control={control}
            label="First Name"
          />
          <FieldV2
            name="lastName"
            isRequired
            disabled={isLoading}
            control={control}
            label="Last Name"
          />
        </Box>
        <Box sx={style.row}>
          <FieldV2
            name="userName"
            isRequired
            disabled={isLoading}
            control={control}
            label="User Name"
          />
          <FieldV2
            name="email"
            isRequired
            disabled={isLoading}
            control={control}
            label="Email Address"
          />
        </Box>
        <Box sx={style.row}>
          <FieldV2
            type="switch"
            name="isActive"
            isRequired
            disabled={isLoading}
            control={control}
            label="Active"
          />
          <FieldV2
            minWidth="300px"
            type="autocomplete"
            name="role"
            isRequired
            disabled={isLoading}
            label="Role"
            control={control}
            autoCompleteHeight={150}
            options={rolesOptionsModified}
          />
        </Box>
        {defaultValues?.id && (
          <Box sx={style.row}>
            <FieldV2
              type="richText"
              name="emailSignature"
              isRequired
              disabled={isLoading}
              control={control}
              label="Email Signature"
            />
          </Box>
        )}
        <ModalFooter>
          <ButtonV2
            type="button"
            disabled={isSubmitting || isLoading}
            variant="outlined"
            onClick={onClose}
          >
            Cancel
          </ButtonV2>
          <ButtonV2 type="submit" disabled={isSubmitting || isLoading}>
            Save
          </ButtonV2>
        </ModalFooter>
      </form>
    </FormProvider>
  );
};

export default AddAgentModalForm;
